import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
var _excluded = ["ehr"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { mapValues } from 'lodash';
import { createCrud, createQueryKey, useAxiosClient, useQuery } from '@lumahealthhq/ui-model';
var basePath = 'integrators';
var crud = createCrud(basePath);
export function useIntegratorApiMany(options) {
  var axiosClient = useAxiosClient();
  var variant = 'v2/{basePath}/apis';
  function queryFn() {
    return _queryFn.apply(this, arguments);
  }
  function _queryFn() {
    _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var url, _yield$axiosClient$ge, data, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            url = variant.replace('{basePath}', basePath);
            _context.next = 3;
            return axiosClient.get(url);
          case 3:
            _yield$axiosClient$ge = _context.sent;
            data = _yield$axiosClient$ge.data;
            // WORKAROUND: Ensure all items have a method
            result = mapValues(data.result, function (items) {
              return items.map(function (item) {
                return _extends({}, item, {
                  method: item.method || 'POST'
                });
              });
            });
            return _context.abrupt("return", result);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _queryFn.apply(this, arguments);
  }
  var queryKey = createQueryKey(basePath, variant);
  return useQuery(queryKey, queryFn, options);
}
export function useIntegratorConfigurationMany(params, options) {
  var axiosClient = useAxiosClient();
  var variant = '{basePath}/configuration';
  function queryFn() {
    return _queryFn2.apply(this, arguments);
  }
  function _queryFn2() {
    _queryFn2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var url, _yield$axiosClient$ge2, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            url = variant.replace('{basePath}', basePath);
            _context2.next = 3;
            return axiosClient.get(url, {
              params: params
            });
          case 3:
            _yield$axiosClient$ge2 = _context2.sent;
            data = _yield$axiosClient$ge2.data;
            return _context2.abrupt("return", data);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _queryFn2.apply(this, arguments);
  }
  var queryKey = createQueryKey(basePath, variant, params);
  return useQuery(queryKey, queryFn, options);
}

// TODO still working on a new endpoint and response format

export function useIntegratorConfigurationByEHR(_ref, options) {
  var ehr = _ref.ehr,
    params = _objectWithoutProperties(_ref, _excluded);
  var axiosClient = useAxiosClient();
  var variant = '{basePath}/configuration/{ehr}';
  function queryFn() {
    return _queryFn3.apply(this, arguments);
  }
  function _queryFn3() {
    _queryFn3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var url, _yield$axiosClient$ge3, data;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            url = variant.replace('{basePath}', basePath).replace('{ehr}', ehr);
            _context3.next = 3;
            return axiosClient.get(url, {
              params: params
            });
          case 3:
            _yield$axiosClient$ge3 = _context3.sent;
            data = _yield$axiosClient$ge3.data;
            return _context3.abrupt("return", data);
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _queryFn3.apply(this, arguments);
  }
  var queryKey = createQueryKey(basePath, variant, params, [ehr]);
  return useQuery(queryKey, queryFn, options);
}
export var useIntegratorManyV1 = crud.makeFindMany('{basePath}');